<template>
    <div>

        <section class="before">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <a href="https://www.tempurpedic.com/">
                            <img src="@/assets/images/main/tempurpedic-logo.png" alt="Tempur-Pedic" class="before__image">
                        </a>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
export default {
    name: 'before',
    mounted () {
    }
}
</script>

<style lang="scss" scoped>

    .before {
        margin-top: 50px;
        text-align: center;

        @media (min-width: 992px) {
            margin-top: 150px;
        }

        &__image {
            max-height: 150px;
            margin-bottom: 20px;
        }
    }

</style>
